import './loader.css'

const Loader = () => {
    return (
            <div class="no-freeze-spinner">
                <div id="no-freeze-spinner">
                    <div>
                    <i class="material-icons">
                        flutter_dash
                    </i>
                    <i class="material-icons">
                        pets
                    </i>
                    <i class="material-icons">
                        cruelty_free
                    </i>
                    <div>
                    </div>
                    </div>
                </div>
            </div>
    )
}

export default Loader
